// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hover {
  color: #045976;
  text-decoration: underline;
  font-weight: bold;
}
.no-hover {
  color: #707070;
}
.child-selected {
  color: #0080ab;
}

.delimiter-style {
  font-weight: 500;
  color: #707070;
}

.delimiter-base {
  margin-left: 24px;
  font-weight: 500;
  color: #707070;
  margin-top: -1px;
}

.delimiter-hover {
  margin-left: 4px;
  margin-top: -7px;
}

.close-icon-div {
  padding-left: 5px;
  margin-top: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
}
.ta-top-level-nav-container > * {
}
.ta-top-level-nav-container {
  width: 100%;
  background-color: rgba(0, 126, 167, 1);
  height: 40px;
}
.ta-top-level-nav > * {
  /* margin-right: 30px; */
  /* padding: 2px; */
}

.ta-center-box svg:hover {
  fill: white;
}
.acc-header {
  padding-top: 58px;
}
.ta-top-level-nav > .selected {
  /* margin-right: 30px; */
  background: rgba(0, 126, 167, 1);
  color: white;
  padding-left: 8px;
  padding-right: 8px;
}
.ta-top-level-nav > .selectable {
  /* margin-right: 30px; */
  cursor: pointer;
  padding-left: 8px;
  padding-right: 8px;
}
.ta-top-level-nav > .gear {
  /* margin-right: 30px; */
  margin-top: 5px;
}
.ta-top-level-nav {
  /* border: 1px solid rgba(0, 126, 167, 1); */
  border-radius: 2px;
  /* padding: 2px; */
}
.ta-second-level-nav > * {
  margin-right: 30px;
}
.ta-second-level-nav > li {
  display: inherit;
}
.ta-second-level-nav {
  padding-top: 8px;
  padding-left: 0px;
}

.ta-overrides > li {
  display: inherit;
}
/* .ta-second-level-nav-container{
  height:100%;
  min-height:100%;
} */

.ta-link-override {
  margin-left: 10px;
}

.ta-second-nav-cont {
  margin-bottom: 10px;
  min-height: 30px;
}
.ta-second-nav-cont-action {
  position: absolute;
  right: 20px;
}

.ta-button {
  height: 28px;
  border-style: none;
  background-color: rgba(0, 126, 167, 1);
  border-radius: 2px;
  border-color: 1px solid rgba(0, 126, 167, 1);
  color: #fff;
}

.ta-button-left {
  margin-right: 20px;
}

.ta-button-right {
  margin-left: 20px;
}

.ta-search {
  height: 25px;
  border-bottom: 1px solid grey;
}
.ta-secondary-nav-link {
  text-decoration: none;
  color: rgba(88, 89, 91, 1);
  padding-left: 4px;
  padding-right: 4px;
}
.ta-active {
  color: rgba(0, 126, 167, 1);
  text-decoration: underline;
  font-weight: bold;
}
.ta-inactive {
  color: blue;
  text-decoration: none;
}

.ta-data-details {
  position: absolute;
  right: 0;
}

.ta-floppy {
  color: blue;
}
.ta-circle-selected {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  background: blue;
  border: 1px solid blue;
  margin-right: 3px;
  margin-top: 3px;
  line-height: 16px;
}

.ta-circle {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 16px;
  color: grey;
  text-align: center;
  background: white;
  border: 1px solid grey;
  margin-right: 3px;
  margin-top: 3px;
  line-height: 16px;
}

.ta-center-box {
  display: flex;
  border-right: 1px solid white;
  padding-right: 10px;
  height: 103%;
  align-items: center;
  justify-content: center;
}
.ta-home-box {
  width: 41px;
  border-right: 1px solid white;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ta-home-box-selected {
  background-color: #045976;
}
.home-icon:hover > svg {
  fill: white !important;
}

.ta-nav-icons {
  /* padding-left: 4px;
  padding-right: 4px; */
}

.ta-grid-container {
  height: 100%;
  display: flex;
  width: 100%;
  top: 63px;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
}

.ta-nav-labels {
  line-height: 32px;
}

.ta-update-lbl {
  font-weight: bold;
}

.ta-unsaved-lbl {
  padding-left: 8px;
}

.ta-modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 1rem;
  z-index: 9999;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: auto;
}

.ta-modal {
  width: 400px;
  height: 100px;
  background-color: #fff;
  border: solid 1px rgba(88, 89, 91, 1);
}
.ta-modal-content {
  position: relative;
  height: 100%;
}
.ta-modal-buttons {
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
}
.ta-modal-title {
  border-bottom: 1px solid rgba(88, 89, 91, 1);
  text-align: center;
}
.ta-modal-ok-button {
  margin-right: 30px;
}
.app-home {
  cursor: pointer;
  font-weight: 400;
  font-size: 12px;
  color: #707070;
}

/* ── Unified Folder Chip breadcrumb ─────────────────────────────────────── */
/* The ta-tln fixed wrapper has pointer-events:none so it never blocks page content
   below (e.g. landing page search box). Restore pointer-events for all interactive
   children — the tab bar container and all breadcrumb elements. */
.ta-tln .ta-top-level-nav-container,
.ta-tln-div-child .bc-row,
.ta-tln-div-child .CSD-Stuff,
.ta-tln-div-child .app-home,
.ta-tln-div-child [data-testid="breadcrumb-item-app-home"],
.ta-tln-div-child .bc-delim-chevron {
  pointer-events: auto;
}

.bc-chip {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  border: 1.5px solid #e8c4a0;
  border-radius: 5px;
  /* padding: 3px 6px 3px 6px; */
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 3px;
  padding-right: 2px;
  min-width: 0;
  overflow: hidden;
}
/* Root/anchor folder sits flush against the chip's left padding — no extra left gap */
.bc-chip > .CSD-Stuff:first-child .bc-folder-label {
  padding-left: 0 !important;
}

/* Folder / group label */
.bc-folder-label {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #b5652a;
  font-weight: 400;
  font-size: 13px;
  cursor: pointer;
  position: relative;
  padding-top: 2px;
  padding-bottom: 2px;
  flex: 0 1 auto;
  min-width: 0;
}
.bc-folder-label.bc-folder-active {
  color: #8a4a1c;
  font-weight: 700;
  text-decoration: underline;
  text-decoration-color: #8a4a1c;
}

/* Report label — teal link */
.bc-report-label {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #0080ab;
  font-size: 13px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  position: relative;
  flex: 0 1 auto;
  min-width: 0;
}
.bc-report-label:hover {
  background: #e0f3f8;
  text-decoration: underline;
}

/* Active report — teal pill */
/* font-weight intentionally omitted (same as inactive) to prevent layout-width shifts */
.bc-report-active {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #fff;
  background-color: #045976;
  border-radius: 5px;
  padding: 2px 6px 2px 6px;
  font-size: 13px;
  cursor: default;
  position: relative;
  flex: 0 1 auto;
  min-width: 0;
}
/* Keep the white X white on hover — overrides the global svg:hover { fill: black } rule */
.bc-report-active span svg:hover {
  fill: white;
}

/* Report directly after a folder chevron — add a touch of breathing room */
.CSD-Stuff:has(.bc-delim-chevron) + .CSD-Stuff .bc-report-label,
.CSD-Stuff:has(.bc-delim-chevron) + .CSD-Stuff .bc-report-active {
  margin-left: 4px;
}

/* Report peer (dot-separated siblings e.g. folderA > reportA · reportB) */
.CSD-Stuff:has(.bc-delim-dot) + .CSD-Stuff .bc-report-label,
.CSD-Stuff:has(.bc-delim-dot) + .CSD-Stuff .bc-report-active {
  margin-left: 4px;
}

/* Chip delimiters */
.bc-delim-chevron {
  display: inline-flex;
  align-items: center;
  color: #c98a55 !important; /* warm mid-terracotta to match folder chip */
  font-weight: 700;
  font-size: 13px;
  line-height: 1;
  margin-top: -1px !important;
}
.bc-delim-pipe {
  display: inline-flex;
  align-items: center;
  color: #7ec8dc !important;
  font-weight: 700;
}
.bc-delim-dot {
  display: inline-flex;
  align-items: center;
  color: #9ca3af !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
}

/* Tighten delimiter spacing inside the chip */
.bc-chip .delimiter-base {
  margin-left: 4px;
  margin-top: 0;
  flex-shrink: 0;
}
.bc-chip .delimiter-hover {
  margin-left: 4px;
  margin-top: 0;
}

/* Outer row that holds bare groups and chips side-by-side */
.bc-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

/* Bare report group — no chip wrapper, flex row */
.bc-bare-group {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
}

/* Bare-group delimiter spacing (outside a chip) */
.bc-bare-group .delimiter-base {
  margin-left: 4px;
  margin-top: 0;
  flex-shrink: 0;
}
.bc-bare-group .delimiter-hover {
  margin-left: 4px;
  margin-top: 0;
}

/* Equal shrinking — each crumb item (CSD-Stuff) uses its natural width; shrinks only when row overflows */
.bc-chip .CSD-Stuff,
.bc-bare-group .CSD-Stuff {
  flex: 0 1 auto;
  min-width: 0;
}

/* Label text — outer flex item + bold-width grid container (for folders) */
.bc-label-text {
  flex: 1 1 0;
  min-width: 0;
}

/* Inner span — where ellipsis actually clips */
.bc-label-inner {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Reserve bold width on folder labels so toggling active/inactive doesn't shift layout.
 * The outer span becomes an inline-grid; the ::after ghost and bc-label-inner share
 * grid-area 1/1 so the grid column is always as wide as the bold text. */
.bc-folder-label .bc-label-text {
  display: inline-grid;
}
.bc-folder-label .bc-label-text::after {
  content: attr(data-text);
  font-weight: 700;
  visibility: hidden;
  height: 0;
  grid-area: 1 / 1;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
}
.bc-folder-label .bc-label-inner {
  grid-area: 1 / 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/topLevelNav/style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;AACA;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;;;GAGG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE;uBACqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,aAAa;EACb,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;;kEAEkE;AAClE;;;;;;EAME,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA,sFAAsF;AACtF;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B,wFAAwF;AACxF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA,0FAA0F;AAC1F;EACE,WAAW;AACb;;AAEA,2EAA2E;AAC3E;;EAEE,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;;EAEE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB,EAAE,6CAA6C;EACxE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,0GAA0G;AAC1G;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;yEAEyE;AACzE;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".hover {\n  color: #045976;\n  text-decoration: underline;\n  font-weight: bold;\n}\n.no-hover {\n  color: #707070;\n}\n.child-selected {\n  color: #0080ab;\n}\n\n.delimiter-style {\n  font-weight: 500;\n  color: #707070;\n}\n\n.delimiter-base {\n  margin-left: 24px;\n  font-weight: 500;\n  color: #707070;\n  margin-top: -1px;\n}\n\n.delimiter-hover {\n  margin-left: 4px;\n  margin-top: -7px;\n}\n\n.close-icon-div {\n  padding-left: 5px;\n  margin-top: 6px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n}\n.ta-top-level-nav-container > * {\n}\n.ta-top-level-nav-container {\n  width: 100%;\n  background-color: rgba(0, 126, 167, 1);\n  height: 40px;\n}\n.ta-top-level-nav > * {\n  /* margin-right: 30px; */\n  /* padding: 2px; */\n}\n\n.ta-center-box svg:hover {\n  fill: white;\n}\n.acc-header {\n  padding-top: 58px;\n}\n.ta-top-level-nav > .selected {\n  /* margin-right: 30px; */\n  background: rgba(0, 126, 167, 1);\n  color: white;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ta-top-level-nav > .selectable {\n  /* margin-right: 30px; */\n  cursor: pointer;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ta-top-level-nav > .gear {\n  /* margin-right: 30px; */\n  margin-top: 5px;\n}\n.ta-top-level-nav {\n  /* border: 1px solid rgba(0, 126, 167, 1); */\n  border-radius: 2px;\n  /* padding: 2px; */\n}\n.ta-second-level-nav > * {\n  margin-right: 30px;\n}\n.ta-second-level-nav > li {\n  display: inherit;\n}\n.ta-second-level-nav {\n  padding-top: 8px;\n  padding-left: 0px;\n}\n\n.ta-overrides > li {\n  display: inherit;\n}\n/* .ta-second-level-nav-container{\n  height:100%;\n  min-height:100%;\n} */\n\n.ta-link-override {\n  margin-left: 10px;\n}\n\n.ta-second-nav-cont {\n  margin-bottom: 10px;\n  min-height: 30px;\n}\n.ta-second-nav-cont-action {\n  position: absolute;\n  right: 20px;\n}\n\n.ta-button {\n  height: 28px;\n  border-style: none;\n  background-color: rgba(0, 126, 167, 1);\n  border-radius: 2px;\n  border-color: 1px solid rgba(0, 126, 167, 1);\n  color: #fff;\n}\n\n.ta-button-left {\n  margin-right: 20px;\n}\n\n.ta-button-right {\n  margin-left: 20px;\n}\n\n.ta-search {\n  height: 25px;\n  border-bottom: 1px solid grey;\n}\n.ta-secondary-nav-link {\n  text-decoration: none;\n  color: rgba(88, 89, 91, 1);\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.ta-active {\n  color: rgba(0, 126, 167, 1);\n  text-decoration: underline;\n  font-weight: bold;\n}\n.ta-inactive {\n  color: blue;\n  text-decoration: none;\n}\n\n.ta-data-details {\n  position: absolute;\n  right: 0;\n}\n\n.ta-floppy {\n  color: blue;\n}\n.ta-circle-selected {\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  font-size: 16px;\n  color: #fff;\n  text-align: center;\n  background: blue;\n  border: 1px solid blue;\n  margin-right: 3px;\n  margin-top: 3px;\n  line-height: 16px;\n}\n\n.ta-circle {\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  font-size: 16px;\n  color: grey;\n  text-align: center;\n  background: white;\n  border: 1px solid grey;\n  margin-right: 3px;\n  margin-top: 3px;\n  line-height: 16px;\n}\n\n.ta-center-box {\n  display: flex;\n  border-right: 1px solid white;\n  padding-right: 10px;\n  height: 103%;\n  align-items: center;\n  justify-content: center;\n}\n.ta-home-box {\n  width: 41px;\n  border-right: 1px solid white;\n  display: -ms-flexbox;\n  display: -moz-flex;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ta-home-box-selected {\n  background-color: #045976;\n}\n.home-icon:hover > svg {\n  fill: white !important;\n}\n\n.ta-nav-icons {\n  /* padding-left: 4px;\n  padding-right: 4px; */\n}\n\n.ta-grid-container {\n  height: 100%;\n  display: flex;\n  width: 100%;\n  top: 63px;\n  position: relative;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.ta-nav-labels {\n  line-height: 32px;\n}\n\n.ta-update-lbl {\n  font-weight: bold;\n}\n\n.ta-unsaved-lbl {\n  padding-left: 8px;\n}\n\n.ta-modal-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  padding: 1rem;\n  z-index: 9999;\n  opacity: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ta-modal {\n  width: 400px;\n  height: 100px;\n  background-color: #fff;\n  border: solid 1px rgba(88, 89, 91, 1);\n}\n.ta-modal-content {\n  position: relative;\n  height: 100%;\n}\n.ta-modal-buttons {\n  position: absolute;\n  bottom: 0;\n  text-align: center;\n  width: 100%;\n}\n.ta-modal-title {\n  border-bottom: 1px solid rgba(88, 89, 91, 1);\n  text-align: center;\n}\n.ta-modal-ok-button {\n  margin-right: 30px;\n}\n.app-home {\n  cursor: pointer;\n  font-weight: 400;\n  font-size: 12px;\n  color: #707070;\n}\n\n/* ── Unified Folder Chip breadcrumb ─────────────────────────────────────── */\n/* The ta-tln fixed wrapper has pointer-events:none so it never blocks page content\n   below (e.g. landing page search box). Restore pointer-events for all interactive\n   children — the tab bar container and all breadcrumb elements. */\n.ta-tln .ta-top-level-nav-container,\n.ta-tln-div-child .bc-row,\n.ta-tln-div-child .CSD-Stuff,\n.ta-tln-div-child .app-home,\n.ta-tln-div-child [data-testid=\"breadcrumb-item-app-home\"],\n.ta-tln-div-child .bc-delim-chevron {\n  pointer-events: auto;\n}\n\n.bc-chip {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  border: 1.5px solid #e8c4a0;\n  border-radius: 5px;\n  /* padding: 3px 6px 3px 6px; */\n  padding-top: 1px;\n  padding-bottom: 1px;\n  padding-left: 3px;\n  padding-right: 2px;\n  min-width: 0;\n  overflow: hidden;\n}\n/* Root/anchor folder sits flush against the chip's left padding — no extra left gap */\n.bc-chip > .CSD-Stuff:first-child .bc-folder-label {\n  padding-left: 0 !important;\n}\n\n/* Folder / group label */\n.bc-folder-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  color: #b5652a;\n  font-weight: 400;\n  font-size: 13px;\n  cursor: pointer;\n  position: relative;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n.bc-folder-label.bc-folder-active {\n  color: #8a4a1c;\n  font-weight: 700;\n  text-decoration: underline;\n  text-decoration-color: #8a4a1c;\n}\n\n/* Report label — teal link */\n.bc-report-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  color: #0080ab;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 4px;\n  position: relative;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n.bc-report-label:hover {\n  background: #e0f3f8;\n  text-decoration: underline;\n}\n\n/* Active report — teal pill */\n/* font-weight intentionally omitted (same as inactive) to prevent layout-width shifts */\n.bc-report-active {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  color: #fff;\n  background-color: #045976;\n  border-radius: 5px;\n  padding: 2px 6px 2px 6px;\n  font-size: 13px;\n  cursor: default;\n  position: relative;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n/* Keep the white X white on hover — overrides the global svg:hover { fill: black } rule */\n.bc-report-active span svg:hover {\n  fill: white;\n}\n\n/* Report directly after a folder chevron — add a touch of breathing room */\n.CSD-Stuff:has(.bc-delim-chevron) + .CSD-Stuff .bc-report-label,\n.CSD-Stuff:has(.bc-delim-chevron) + .CSD-Stuff .bc-report-active {\n  margin-left: 4px;\n}\n\n/* Report peer (dot-separated siblings e.g. folderA > reportA · reportB) */\n.CSD-Stuff:has(.bc-delim-dot) + .CSD-Stuff .bc-report-label,\n.CSD-Stuff:has(.bc-delim-dot) + .CSD-Stuff .bc-report-active {\n  margin-left: 4px;\n}\n\n/* Chip delimiters */\n.bc-delim-chevron {\n  display: inline-flex;\n  align-items: center;\n  color: #c98a55 !important; /* warm mid-terracotta to match folder chip */\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 1;\n  margin-top: -1px !important;\n}\n.bc-delim-pipe {\n  display: inline-flex;\n  align-items: center;\n  color: #7ec8dc !important;\n  font-weight: 700;\n}\n.bc-delim-dot {\n  display: inline-flex;\n  align-items: center;\n  color: #9ca3af !important;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1;\n}\n\n/* Tighten delimiter spacing inside the chip */\n.bc-chip .delimiter-base {\n  margin-left: 4px;\n  margin-top: 0;\n  flex-shrink: 0;\n}\n.bc-chip .delimiter-hover {\n  margin-left: 4px;\n  margin-top: 0;\n}\n\n/* Outer row that holds bare groups and chips side-by-side */\n.bc-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 6px;\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Bare report group — no chip wrapper, flex row */\n.bc-bare-group {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Bare-group delimiter spacing (outside a chip) */\n.bc-bare-group .delimiter-base {\n  margin-left: 4px;\n  margin-top: 0;\n  flex-shrink: 0;\n}\n.bc-bare-group .delimiter-hover {\n  margin-left: 4px;\n  margin-top: 0;\n}\n\n/* Equal shrinking — each crumb item (CSD-Stuff) uses its natural width; shrinks only when row overflows */\n.bc-chip .CSD-Stuff,\n.bc-bare-group .CSD-Stuff {\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n/* Label text — outer flex item + bold-width grid container (for folders) */\n.bc-label-text {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* Inner span — where ellipsis actually clips */\n.bc-label-inner {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Reserve bold width on folder labels so toggling active/inactive doesn't shift layout.\n * The outer span becomes an inline-grid; the ::after ghost and bc-label-inner share\n * grid-area 1/1 so the grid column is always as wide as the bold text. */\n.bc-folder-label .bc-label-text {\n  display: inline-grid;\n}\n.bc-folder-label .bc-label-text::after {\n  content: attr(data-text);\n  font-weight: 700;\n  visibility: hidden;\n  height: 0;\n  grid-area: 1 / 1;\n  pointer-events: none;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.bc-folder-label .bc-label-inner {\n  grid-area: 1 / 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
